import data from './data'
import steps from './steps'
import installation from './installation'
import statistics from './statistics'

export default function* sagas() {
  yield [
    data(),
    steps(),
    installation(),
    statistics()
  ];
}